'use client';

import { type ReactNode, createContext, useContext, useRef } from 'react';
import { type StoreApi, useStore } from 'zustand';

import { type projectStore, createProjectStore } from '@/stores/projectStore';

export const ProjectStoreContext = createContext<StoreApi<projectStore> | null>(null);

export interface ProjectStoreProviderProps {
  children: ReactNode;
}

export const ProjectStoreProvider = ({ children }: ProjectStoreProviderProps) => {
  const store = useRef<StoreApi<projectStore>>();

  if (!store.current) {
    store.current = createProjectStore();
    store.current.getState().fetchByTypeKey();
  }

  return <ProjectStoreContext.Provider value={store.current}>{children}</ProjectStoreContext.Provider>;
};

export const useProjectStore = <T,>(selector: (store: projectStore) => T): T => {
  const projectStoreContext = useContext(ProjectStoreContext);

  if (!projectStoreContext) {
    throw new Error(`useProjectStore must be use within ProjectStoreProvider`);
  }

  return useStore(projectStoreContext, selector);
};
